import Lenis from "lenis";

let lenis = null;

export const initLenis = () => {
  lenis = new Lenis({ duration: 1.2, smoothWheel: true });
  let id;
  const raf = (t) => {
    lenis.raf(t);
    id = requestAnimationFrame(raf);
  };
  id = requestAnimationFrame(raf);
  return () => {
    cancelAnimationFrame(id);
    lenis.destroy();
    lenis = null;
  };
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

const CAL_URL = "https://cal.com/ruiguedes/15min";

export const openCal = () => window.open(CAL_URL, "_blank", "noopener");

export const goToContact = (interest) => {
  window.dispatchEvent(new CustomEvent("si:interest", { detail: interest }));
  scrollToId("contacto");
};
